<!-- @prettier -->
<template>
  <Editor
    :init="config"
    tinymce-script-src="https://cdnjs.cloudflare.com/ajax/libs/tinymce/7.4.1/tinymce.min.js"
  />
</template>
<script setup>
  import { inject } from "vue";
  import Editor from "@tinymce/tinymce-vue";
  import getCssVariable from "@/utilities/getCssVariable.js";

  const props = defineProps({ height: { type: Number } });

  const appState = inject("appState");

  const isDeveloper = appState.user.authorities.map((a) => a.authority).includes("ROLE_DEVELOPER");
  const isLightMode = appState.user.preferences.appLayoutMode === "light";

  const config = {
    license_key: "gpl",
    height: props.height,
    menubar: false,
    statusbar: false,
    branding: false,
    plugins: ["table", "lists", "link", ...(isDeveloper ? ["code"] : [])],
    toolbar: [
      { name: "formatting", items: ["bold", "italic", "underline", "strikethrough"] },
      { name: "colors", items: ["forecolor", "backcolor"] },
      { name: "alignment", items: ["alignleft", "aligncenter", "alignright"] },
      { name: "lists", items: ["bullist", "numlist", "indent", "outdent"] },
      { name: "table", items: ["link", "table"] },
      ...(isDeveloper ? [{ name: "developer", items: ["code"] }] : [])
    ],
    skin: isLightMode ? "oxide" : "oxide-dark",
    content_css: isLightMode ? "default" : "dark",
    highlight_on_focus: false,
    content_style: `html { font-family: ${getCssVariable("--font-body")}; font-size: 14px; }`,
    convert_urls: false
  };
</script>

<style lang="scss">
  .tox.tox-tinymce {
    border: 1px solid var(--color-border);
    transition: 0.2s all ease-in-out;
    .p-invalid + & {
      border-color: var(--color-error);
    }
    .loading + & {
      opacity: 0.5;
      pointer-events: none;
    }
  }
  .tox.tox-tinymce-aux {
    z-index: 9999;
  }
</style>
